export default {
	getUnreadCount: (state) => {
		return state.unreadCount;
	}
};
